import SocialTheme from '../../../../entity/SocialTheme';
import SocialThemeCategory from '../../../../entity/SocialThemeCategory';

export interface SocialThemeTab {
  themeCategory: SocialThemeCategory;
  themes: SocialTheme[];
}

export enum ModalCloseActionType {
  SETTINGS = 'settings',
  START = 'start',
  SAVE = 'save',
}
